import moment, { Moment } from 'moment';
import { ISO8601 } from './model/ISO8601';
import { State } from '@meraki-internal/state';

export class Clock extends State {

    private emitAt: ISO8601[] = [];

    private setEmitTimeouts = () => {
        for (const when of this.emitAt) {
            const msUntil = moment(when).diff(moment(this.now()));
            if (msUntil > 0) {
                setTimeout(() => this.setState({}), msUntil + 1);
            }
        };
    };

    now = () => Date.now();

    registerEmitAt = (...times: string[]) => {
        this.emitAt = [...this.emitAt, ...times];
        this.setEmitTimeouts();
    };

    // IOC.get('<Class>').clock.mock(time => time.add(15, 'days'))
    mock = (del: (time: Moment) => Moment) => {
        this.now = () => del(moment()).valueOf();
        this.setEmitTimeouts();
    };

    // IOC.get('<Class>').clock.mockFrom('2025-03-01T16:00:00.000Z')
    mockFrom = (time: ISO8601) => {
        const offset = moment().diff(time);
        this.now = () => moment().subtract(offset, 'ms').valueOf();
        this.setEmitTimeouts();
    };
};
